// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"3c271fe2","121":"52ab9d3a","180":"b1aa5c9b","221":"554659aa","260":"e9a3b51f","299":"efd4fc07","483":"b3ee356c","606":"3a43131b","672":"0b3e8316","719":"0b9b5568","773":"d16aa8d5","830":"44492444","922":"5dcf1eef"}[chunkId] + ".chunk.js";
};